import React from "react";
import ReactDOM from "react-dom";
import { MonetaryAmount } from "../../../app/domain/monetary-amount";
import { findEmployeeAdjustments } from "../../../infrastructure/repository/adjustment-repository";
import { findCompanyDetail } from "../../../infrastructure/repository/company-repository";
import { findEmployeeDetail } from "../../../infrastructure/employees-cache";
import { findCardEmployee } from "../../../infrastructure/repository/card-repository";
import { showErrorMessage } from "../../commons/show-error-message";
import { logError, addContextLog } from "../../../infrastructure/log";
import HexModal from "../../../app/components/modals/HexModal";
import ShowDeleteEmployeesModal from "../../../app/components/modals/employee/show-delete-employees-modal";
import { translate } from "../../../infrastructure/translate/localization";

function renderConfirmModal({
  employee,
  page,
  detailAdjustments,
  card,
  country,
}) {
  const {
    formatAdjustments,
    formatRecurrent,
    formatPending,
    adjustmentsCsvString,
  } = detailAdjustments || {};

  const defaultAmount = {
    amountInCents: 0,
    currency: "EUR",
  };

  const totalAccumulated = card?.totalAccumulated || defaultAmount;
  let amountHistoryAccumulated = MonetaryAmount.ZERO;
  amountHistoryAccumulated = amountHistoryAccumulated.add(
    MonetaryAmount.ofCurrency(totalAccumulated)
  );

  const totalFunds = card?.totalFunds || defaultAmount;
  let amountHistoryFunds = MonetaryAmount.ZERO;
  amountHistoryFunds = amountHistoryFunds.add(
    MonetaryAmount.ofCurrency(totalFunds)
  );

  ReactDOM.render(
    <HexModal>
      <ShowDeleteEmployeesModal
        employee={employee}
        page={page}
        adjustments={formatAdjustments?.[0]}
        pendingPayment={formatPending}
        recurrentPayment={formatRecurrent}
        adjustmentsCsvString={adjustmentsCsvString}
        card={card}
        totalCardFunds={totalFunds.amountInCents}
        totalHistoryOfFunds={amountHistoryFunds.toUnitary()}
        totalAccumulated={totalAccumulated.amountInCents}
        totalHistoryOfAccumulated={amountHistoryAccumulated.toUnitary()}
        country={country}
      />
    </HexModal>,
    document.getElementById("modal-container")
  );
}

export async function displayDeleteEmployeesModal(employeeId, page) {
  try {
    const { data: companyDetail } = await findCompanyDetail();
    const companyId = companyDetail.id;
    const { data: detailAdjustments } = await findEmployeeAdjustments({
      companyId,
      employeeId,
    });
    const employee = await findEmployeeDetail({ companyId, employeeId });
    const card = await findCardEmployee({ companyId, employeeId });

    addContextLog("info", "displayChangeModelModal", "display-screen", {
      companyId,
      detailAdjustments,
      employee,
      card: card.data,
    });
    renderConfirmModal({
      employee,
      page,
      detailAdjustments,
      card: card.data,
      country: companyDetail.countryISO2Code,
    });
  } catch (e) {
    logError(
      e,
      `Error to displayDeleteEmployeesModal with employee ${employeeId}`
    );
    showErrorMessage(translate("common-messages.basic-error-message"), true, e);
  }
}
